import React, {useState} from 'react'
import {AppContent} from '../../../../_metronic/helpers/components/AppContent'
import {HandleSaleStock} from '../../../../context/HandleSaleStock'
import {LevelOne} from './Levels/LevelOne'
import {LevelThree} from './Levels/LevelThree'
import {LevelFour} from './Levels/LevelFour'
import {BsArrowLeft} from 'react-icons/bs'
import {LevelFive} from './Levels/LevelFive'
import {LevelSix} from './Levels/LevelSix'

const StockSale = () => {
  const [page, setPage] = useState(1)
  const [stockUnit, setStockUnit] = useState(1)
  const [stock, setStock] = useState(1)
  const [price, setPrice] = useState(1)
  const [payType, sePayType] = useState(1)
  const [basePrice, setBasePrice] = useState(55000000)
  const [order,setOrder] = useState<Object>({})
  const valueCTX: HandleSaleStock =  {
    page: page,
    setPage: setPage,
    stock: stock,
    setStock: setStock,
    stockUnit: stockUnit,
    setStockUnit: setStockUnit,
    price: price,
    setPrice: setPrice,
    basePrice: basePrice,
    setBasePrice: setBasePrice,
    payType: payType,
    sePayType: sePayType,
    order: order,
    setOrder: setOrder
  }
  return (
    <div>
      <HandleSaleStock.Provider value={valueCTX}>
        <AppContent>
          <div dir={'rtl'} className={'flex justify-around items-center mt-5'}>
           <div className={'flex flex-col'}>
             <div  className={`p-5 cursor-pointer black-white rounded-full w-20 h-20 + ${page === 1 ? 'bg-success text-white' : 'bg-gray-200'}`}>
               <p className={'mt-2'}>1</p>
             </div>
             <div className={'mt-2'}>
               <p className={'text-gray-500'}>شروع</p>
             </div>
           </div>
            <BsArrowLeft className={'mb-13'} size={25} />
            <div className={'flex flex-col'}>
              <div  className={`p-5 cursor-pointer black-white rounded-full w-20 h-20 + ${page === 2 ? 'bg-success text-white' : 'bg-gray-200'}`}>
                <p className={'mt-2'}>2</p>
              </div>
              <div className={'mt-2'}>
                <p className={'text-gray-500'}>انتخاب سهام</p>
              </div>
            </div>
            {/*<BsArrowLeft className={'mb-13'} size={25} />*/}
            {/*<div className={'flex flex-col'}>*/}
            {/*  <div onClick={() => setPage(3)} className={`p-5 cursor-pointer black-white rounded-full w-20 h-20 + ${page === 3 ? 'bg-success text-white' : 'bg-gray-200'}`}>*/}
            {/*    <p className={'mt-2'}>3</p>*/}
            {/*  </div>*/}
            {/*  <div className={'mt-2'}>*/}
            {/*    <p className={'text-gray-500'}>انتخاب سهم</p>*/}
            {/*  </div>*/}
            {/*</div>*/}
            <BsArrowLeft className={'mb-13'} size={30} />
            <div className={'flex flex-col'}>
              <div className={`p-5 cursor-pointer black-white rounded-full w-20 h-20 + ${page === 3 ? 'bg-success text-white' : 'bg-gray-200'}`}>
                <p className={'mt-2'}>3</p>
              </div>
              <div className={'mt-2'}>
                <p className={'text-gray-500'}> تعداد سهم</p>
              </div>
            </div>
            <BsArrowLeft className={'mb-13'} size={30} />
            <div className={'flex flex-col'}>
            {/* onClick={() => setPage(4)} */}
              <div className={`p-5 cursor-pointer black-white rounded-full w-20 h-20 + ${page === 4 ? 'bg-success text-white' : 'bg-gray-200'}`}>
                <p className={'mt-2'}>4</p>
              </div>
              <div className={'mt-2'}>
                <p className={'text-gray-500'}>  روش پرداخت </p>
              </div>
            </div>
            <BsArrowLeft className={'mb-13'} size={30} />
            <div className={'flex flex-col'}>
              <div  className={`p-5 cursor-pointer black-white rounded-full w-20 h-20 + ${page === 5 ? 'bg-success text-white' : 'bg-gray-200'}`}>
                <p className={'mt-2'}>5</p>
              </div>
              <div className={'mt-2'}>
                <p className={'text-gray-500'}>  پرداخت  </p>
              </div>
            </div>
          </div>
          <div className={'flex flex-col justify-center h-100 items-center'}>
            {/* {(() => {
              switch(page) {
                case 1: return <LevelOne />
                case 2: return <LevelThree />
                case 3: return <LevelFour />
                case 4: return <LevelFive />
                case 5: return <LevelSix />
              }
            })()} */}
          </div>
        </AppContent>
      </HandleSaleStock.Provider>
    </div>
  )
}

export {StockSale}
